import React from "react";
import { FaTimes } from "react-icons/fa";
import { useMeetingAppContext } from "../../MeetingAppContextDef";
import useIsMobile from "../../hooks/useIsMobile";
import useIsTab from "../../hooks/useIsTab";

const WebsiteSection = ({ settings, onClose, sideBarContainerWidth }) => {
  const { sideBarMode, leftSideBarMode } = useMeetingAppContext();
  const isMobile = useIsMobile();
  const isTab = useIsTab();

  // Calculate left offset when left sidebar is open
  const leftOffset =
    !isMobile && !isTab && leftSideBarMode ? sideBarContainerWidth : 0;

  // Calculate width accounting for both left and right sidebars
  const calculateWidth = () => {
    if (isMobile) return "100%";
    if (settings.displayMode === "full") {
      let widthReduction = 0;
      if (leftSideBarMode && !isMobile && !isTab)
        widthReduction += sideBarContainerWidth;
      if (sideBarMode && !isMobile && !isTab)
        widthReduction += sideBarContainerWidth;
      return widthReduction > 0 ? `calc(100% - ${widthReduction}px)` : "100%";
    }
    return "50%";
  };

  return (
    <div
      className={`bg-red-400 fixed ${
        isMobile
          ? "top-[64px] bottom-[80px] right-0"
          : settings.displayMode === "full"
          ? "h-full"
          : "h-full right-0"
      } ${
        !isMobile && settings.displayMode === "full"
          ? ""
          : !isMobile
          ? "top-[5%]"
          : ""
      }`}
      style={{
        zIndex: 999999,
        marginTop: isMobile ? "0" : "60px",
        marginBottom: "0px",
        height: isMobile ? "auto" : "calc(100vh - 100px)",
        left: isMobile ? "0" : leftOffset > 0 ? `${leftOffset}px` : "0",
        width: calculateWidth(),
      }}
    >
      <button
        onClick={() => onClose()}
        style={{
          position: "absolute",
          top: 12,
          right: 12,
          zIndex: 20,
          background: "rgba(0,0,0,0.6)",
          border: "none",
          borderRadius: "50%",
          width: 36,
          height: 36,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          cursor: "pointer",
        }}
        aria-label="Close website"
      >
        <FaTimes size={20} />
      </button>
      <iframe
        src={"https://" + settings.link}
        className="w-full h-full"
        style={{
          border: "none",
          pointerEvents: settings.mode === "interactive" ? "auto" : "none",
        }}
        title="Website View"
      />
    </div>
  );
};

export default WebsiteSection;
